<div class="location-card bg-white dark:bg-surface-800 border-gray-200 dark:border-surface-600" [ngClass]="cardType + '-card'">
  <div class="location-card-header">
    <div class="location-icon" [ngClass]="cardType + '-icon'">
      <i class="pi {{ getLocationTypeIcon(location?.type || '') }} {{ getLocationTypeColor(location?.type || '') }}"></i>
    </div>
    <div class="location-info">
      <h3 class="location-title text-gray-600 dark:text-surface-400">{{ title }}</h3>
      <p class="location-name text-gray-900 dark:text-surface-0">{{ location?.name || '-' }}</p>
    </div>
  </div>
  <div class="location-details">
    <p class="location-address text-gray-600 dark:text-surface-400">{{ formatLocationDetails(location) || '-' }}</p>
    <!-- <div class="location-meta" *ngIf="location">
      <span class="coordinates" *ngIf="location.lat && location.lon">
        {{ location.lat | number:'1.6-6' }}, 
        {{ location.lon | number:'1.6-6' }}
      </span>
      <span class="location-type-badge" *ngIf="location.type">
        {{ getLocationTypeLabel(location.type) }}
      </span>
    </div> -->
  </div>
</div>